import { Col, Input, Row } from 'antd';
import AppResult from 'components/appResults';
import React from 'react';
import StudentCard from '../StudentCard/StudentCard';
import './StudentsGridView.css';

const { Search } = Input;

interface StudentsGridViewProps {
  students: any[];
  onDeleteStudent?: (id: string) => void;
  isLoading?: boolean;
}

const StudentsGridView: React.FC<StudentsGridViewProps> = ({ students, onDeleteStudent, isLoading }) => {
  return (
    <div className="students-grid-container">
      {students?.length !== 0 ? <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
        {students.map((student) => (
          <Col key={student.id} xs={24} sm={12} md={8} lg={6} xl={6}>
            <StudentCard data={student} onDelete={onDeleteStudent} isLoading={isLoading} />
          </Col>
        ))}
      </Row> : <AppResult status={"info"} title={"Vous n'avez encore aucun élève dans votre classe."} />}
    </div>
  );
};

export default StudentsGridView;
